const Checkbox = ({
  value,
  label,
  name,
  placeholder,
  type,
  onChange,
  onBlur,
  readOnly,
  disabled,
  checked
}) => <div className="flex items-center" data-sentry-component="Checkbox" data-sentry-source-file="Checkbox.jsx">
    <input id={name} type={type} readOnly={readOnly} disabled={disabled} value={value} name={name} onBlur={onBlur} placeholder={placeholder} onChange={onChange} className="accent-icon-color me-2 size-[14px]" checked={checked} />
    {label && <label htmlFor={name} // Correctly associate the label with the input
  className="text-supportiveMediumGray text-sm font-medium">
        {label}
      </label>}
  </div>;
export default Checkbox;